"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthChangeWatcher = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var auth_1 = require("firebase/auth");
var react_redux_1 = require("react-redux");
var analyticsEventBase_1 = require("../../sdks/firebase/analyticsEventBase");
var messaging_1 = require("firebase/messaging");
var analytics_1 = require("firebase/analytics");
var clientServerTimestamp_1 = require("../../sdks/firebase/clientServerTimestamp");
var firestore_1 = require("firebase/firestore");
var setUnscopeUserClient_1 = require("../../functions/utilities/ref/set/setUnscopeUserClient");
var createErrorAction_1 = require("../../actionCreators/createErrorAction");
var description = 'AuthChangeWatcher';
var AuthChangeWatcher = function (_a) {
    var refreshIdToken = _a.refreshIdToken, onSignIn = _a.onSignIn;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_1.useState)(), authUser = _b[0], setAuthUser = _b[1];
    var currentUserId = (0, react_redux_1.useSelector)(function (state) {
        return state.currentUserId;
    });
    var isNative = (0, react_redux_1.useSelector)(function (state) {
        var _a, _b;
        return (((_a = state.windowMeta) === null || _a === void 0 ? void 0 : _a.platformType) === 'AndroidNative' ||
            ((_b = state.windowMeta) === null || _b === void 0 ? void 0 : _b.platformType) === 'IosNative');
    });
    var signedIntoDashboard = (0, react_redux_1.useSelector)(function (state) { var _a; return (_a = state.cookieStorage) === null || _a === void 0 ? void 0 : _a.signedIntoDashboard; });
    var signedInAnonymously = (0, react_redux_1.useSelector)(function (state) { var _a; return (_a = state.cookieStorage) === null || _a === void 0 ? void 0 : _a.signedInAnonymously; });
    var notificationPermission = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return (_a = state.windowMeta) === null || _a === void 0 ? void 0 : _a.notificationPermission;
    });
    (0, react_1.useEffect)(function () {
        var handleSignOut = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var userId, isAnonymous, dashboardSignOut, anonymousSignOut, messagingSupported, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userId = authUser === null || authUser === void 0 ? void 0 : authUser.uid;
                        isAnonymous = authUser === null || authUser === void 0 ? void 0 : authUser.isAnonymous;
                        dashboardSignOut = signedIntoDashboard && (!userId || isAnonymous);
                        anonymousSignOut = signedInAnonymously && !userId;
                        if (!(dashboardSignOut || anonymousSignOut)) return [3 /*break*/, 6];
                        (0, analyticsEventBase_1.analyticsEventBase)({
                            event: isAnonymous ? 'Sign out anonymous' : 'Sign out',
                        });
                        if (window.onSignOut) {
                            window.onSignOut();
                        }
                        if (!(!isNative && notificationPermission === 'granted')) return [3 /*break*/, 5];
                        return [4 /*yield*/, (0, messaging_1.isSupported)()];
                    case 1:
                        messagingSupported = _a.sent();
                        if (!messagingSupported) return [3 /*break*/, 5];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, (0, messaging_1.deleteToken)((0, messaging_1.getMessaging)())];
                    case 3:
                        _a.sent();
                        dispatch({
                            type: 'SET_WINDOW_META',
                            values: { firebaseMessagingToken: null },
                            description: description,
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        dispatch({
                            type: 'SET_SESSION_STORAGE',
                            description: description,
                            sessionStorage: {},
                            replace: true,
                        });
                        dispatch({
                            type: 'SET_COOKIE_STORAGE',
                            description: description,
                            replace: true, // decided to remove all as default, add to values below if you want to retain some cookies
                            values: {},
                        });
                        dispatch({
                            type: 'SIGN_OUT_SUCCESS',
                            description: description,
                        });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        if (authUser !== undefined) {
            handleSignOut();
        }
    }, [
        authUser,
        notificationPermission,
        isNative,
        dispatch,
        refreshIdToken,
        signedInAnonymously,
        signedIntoDashboard,
    ]);
    (0, react_1.useEffect)(function () {
        var handleSignIn = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var userId, emailVerified, email, isAnonymous, displayName, photoURL, providerType, newUser, error_2;
            var _a, _b, _c, _d;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        userId = authUser === null || authUser === void 0 ? void 0 : authUser.uid;
                        emailVerified = (authUser === null || authUser === void 0 ? void 0 : authUser.emailVerified) || false;
                        email = authUser === null || authUser === void 0 ? void 0 : authUser.email;
                        isAnonymous = authUser === null || authUser === void 0 ? void 0 : authUser.isAnonymous;
                        displayName = authUser === null || authUser === void 0 ? void 0 : authUser.displayName;
                        photoURL = authUser === null || authUser === void 0 ? void 0 : authUser.photoURL;
                        providerType = ((_b = (_a = authUser === null || authUser === void 0 ? void 0 : authUser.providerData) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.providerId)
                            ? (_d = (_c = authUser === null || authUser === void 0 ? void 0 : authUser.providerData) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.providerId
                            : undefined;
                        newUser = (authUser === null || authUser === void 0 ? void 0 : authUser.metadata.lastSignInTime) === (authUser === null || authUser === void 0 ? void 0 : authUser.metadata.creationTime);
                        if (!(userId && userId !== currentUserId)) return [3 /*break*/, 5];
                        (0, analytics_1.setUserId)((0, analytics_1.getAnalytics)(), userId.slice(0, 8));
                        if (!(newUser && !isAnonymous)) return [3 /*break*/, 4];
                        (0, analyticsEventBase_1.analyticsEventBase)({
                            event: 'New user',
                        });
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        // we dont want to affect the reducer yet because currentUser has not been set
                        return [4 /*yield*/, (0, setUnscopeUserClient_1.setUnscopeUserClient)({
                                firestore: (0, firestore_1.getFirestore)(),
                                userId: userId,
                                unscopeUser: {
                                    created: (0, clientServerTimestamp_1.clientServerTimestamp)(),
                                },
                                merge: true,
                            })];
                    case 2:
                        // we dont want to affect the reducer yet because currentUser has not been set
                        _e.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _e.sent();
                        dispatch((0, createErrorAction_1.createErrorAction)({ description: description, error: error_2 }));
                        return [3 /*break*/, 4];
                    case 4:
                        (0, analyticsEventBase_1.analyticsEventBase)({
                            event: isAnonymous ? 'Sign in anonymous' : 'Sign In',
                        });
                        if (window.onSignIn) {
                            window.onSignIn();
                        }
                        onSignIn === null || onSignIn === void 0 ? void 0 : onSignIn(userId);
                        dispatch({
                            type: 'SET_COOKIE_STORAGE',
                            description: description,
                            values: isAnonymous
                                ? {
                                    signedInAnonymously: true,
                                }
                                : {
                                    signedIntoDashboard: true,
                                },
                        });
                        // Make sure user is not already signed in from google sign in
                        dispatch({
                            type: 'SIGN_IN_SUCCESS',
                            description: description,
                            userId: userId,
                            isAnonymous: isAnonymous,
                            user: {
                                emailVerified: emailVerified,
                                email: email || undefined,
                                displayName: displayName || undefined,
                                photoURL: photoURL || undefined,
                                providerType: providerType,
                            },
                        });
                        _e.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        if (authUser !== undefined) {
            handleSignIn();
        }
    }, [
        notificationPermission,
        isNative,
        currentUserId,
        dispatch,
        refreshIdToken,
        onSignIn,
        authUser,
    ]);
    (0, react_1.useEffect)(function () {
        var unsubscribe = (0, auth_1.onAuthStateChanged)((0, auth_1.getAuth)(), function (user) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // seems like firebase returns the same object so we can use it as state
                        setAuthUser(user || null);
                        if (!(user && refreshIdToken)) return [3 /*break*/, 2];
                        return [4 /*yield*/, user.getIdToken(true)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        return function () {
            unsubscribe();
        };
    }, [dispatch, refreshIdToken]);
    return null;
};
exports.AuthChangeWatcher = AuthChangeWatcher;
